// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__41EFl","rowMarginTop":"ResultsWrapper_rowMarginTop__Wezgc","rowMarginBottom":"ResultsWrapper_rowMarginBottom__1aRM0"};